<template>
  <div class="chart_warp">
    <div class="chart_cont" :ref="'graph_' + chartName"></div>
  </div>
</template>

<script>
import { getFormatter } from '@/api/portrait.js'
// import * as echarts from '@/assets/js/echarts.min.js'
export default {
  props: {
    chartName: String,
    detailType: String
  },
  data() {
    return {
      myChart: null,
      option: {
        tooltip: {},
        series: [
          {
            type: 'graph',
            layout: 'none',
            symbolSize: 100,
            roam: false,
            z: 2,
            edgeSymbol: ['circle', 'arrow'],
            edgeSymbolSize: [4, 10],
            edgeLabel: {
              fontSize: 20
            },
            label: {
              show: true,
              color: '#fff'
            },
            itemStyle: {
              color: '#4162E8',
              borderWidth: 5,
              borderColor: '#fff',
            },
            emphasis: {
              scale: false,
            },
            data: [],
            links: [],
            tooltip: {},
          },
          {
            type: 'pie',
            name: 'graphPie',
            center: ['50%', '50%'],
            radius: [35, 120],
            z: 1,
            avoidLabelOverlap: false,
            selectedOffset: 0,
            selectedMode: 'single',
            showEmptyCircle: false,
            minAngle: 30,
            itemStyle: {
              borderRadius: 0,
              borderWidth: 5,
              borderColor: '#fff',
              color: '#D9E0FB',
            },
            label: {
              position: 'inside',
              color: '#595959',
              fontSize: 14,
              lineHeight: 20,
            },
            emphasis: {
              scale: false,
              itemStyle: {
                color: '#F1F3FE',
              },
              label: {
                color: '#4162E8',
              },
            },
            // select: {
            //   itemStyle: {
            //     color: '#F1F3FE',
            //   },
            //   label: {
            //     color: '#4162E8',
            //   },
            // },
            data: [],
            animationDuration: 100,
            animationDurationUpdate: 0,
            animation: false,
            tooltip: {
              formatter: (params) => {
                return `${params.name}`
              }
            }
          }
        ],
        animation: false
      }
    }
  },
  methods: {
    destroy() {
      this.myChart && this.myChart.clear();
    },
    setOption(val) {
      let nodes = val.node ? [val.node] : []
      if (nodes.length == 0) {
        return;
      }
      let labels = val.labels == null ? [] : val.labels
      this.option.series[0].data = this.setDataItem(nodes)
      this.option.series[1].data = labels
      this.option.series[1].startAngle = labels.length == 2 ? 0 : 90
      this.$nextTick(() => {
        this.loadChart('graph_' + this.chartName)
      })
    },
    loadChart(chartId, init = true) {
      let chartDom = this.$refs[chartId];
      this.myChart = echarts.init(chartDom)
      this.myChart.setOption(this.option)
      // 事件监听
      if (init) {
        this.myChart.off('click')
        this.myChart.on('click', (params) => {
          if (params.seriesType === "pie") {
            this.$emit('showFullChart', params)
          }
        });
      }
    },
    setDataItem(node, opt) {
      let datas = [], dT = this.detailType, data = echarts.util.clone(node)
      // 设置节点数据
      data.map((item, i) => {
        if (!opt || (opt && opt.id != item.id)) {
          let nodeName = item.label
          item.tooltip = {
            formatter: (params) => {
              return params.data.label
            }
          }
          // 计算文字长度 将中文转换为两个字节的英文再计算
          let len = nodeName.replace(/[\u0391-\uFFE5]/g, 'aa').length
          let n = Number(dT) < 4 ? 6 : 12
          item.label = {
            fontSize: Number(dT) < 4 ? 16 : 14,
            lineHeight: Number(dT) < 4 ? 18 : 16,
            formatter: (params) => {// 设置每6个字符长度换行 中文对应2个字符长度
              let val = params.data.label
              if (len > n * 3) {
                let nv = nodeName.slice(0, n * 1.5 - 2)
                val = `${getFormatter(nv, n)}...`
              } else {
                val = getFormatter(nodeName, n)
              }
              return val
            },
          }
          item.x = 100
          item.y = 100
          datas.push(item)
        }
      })
      return datas
    },
  }
}
</script>

<style lang="less" scoped>
.chart_warp {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  overflow: hidden;

  .chart_cont {
    width: 100%;
    height: 100%;
  }
}
</style>
